"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _DropdownList = _interopRequireDefault(require("react-widgets/lib/DropdownList"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _InfoLabel = _interopRequireDefault(require("../../../../components/InfoLabel"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var RepeatConfig = function RepeatConfig(_ref) {
  var fields = _ref.fields;
  var isRepeated = fields.isRepeated,
    repeatInterval = fields.repeatInterval;
  var repeatIntervalValue = repeatInterval.value;
  var repeatIntervalParts = repeatIntervalValue.split(' ').filter(function (item) {
    return item;
  });
  var repeatIntervalNumber = repeatIntervalParts.length >= 2 ? repeatIntervalParts[0] : '';
  var repeatIntervalUnits = repeatIntervalParts.length >= 2 ? repeatIntervalParts[1] : 'month';
  var _useState = (0, _react.useState)(repeatIntervalUnits),
    _useState2 = _slicedToArray(_useState, 2),
    localRepeatUnits = _useState2[0],
    setLocalRepeatUnits = _useState2[1];
  function onRepeatIntervalNumberChange(updatedNumber) {
    if (!updatedNumber) {
      repeatInterval.onChange('');
      return;
    }
    repeatInterval.onChange("".concat(updatedNumber, " ").concat(localRepeatUnits));
  }
  function onRepeatIntervalUnitsChange(updatedUnits) {
    if (repeatIntervalValue) {
      repeatInterval.onChange("".concat(repeatIntervalNumber, " ").concat(updatedUnits));
    }
    setLocalRepeatUnits(updatedUnits);
  }
  var renderIsRepeatedToggle = /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].repeatToggleContainer
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: isRepeated,
    label: /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Is repeatable",
      optional: true,
      tooltip: "A repeatable data collection wave (DCW) lets users retake a survey. Data from each attempt are saved in the current DCW under distinct timepoints."
    })
  }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
    value: isRepeated.value,
    onChange: function onChange(e) {
      isRepeated.onChange(!isRepeated.value);
    }
  })));
  var renderRepeatInterval = /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('mb-3', _style["default"].repeatIntervalContainer)
  }, /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
    label: "Minimum Repeat Interval",
    optional: true,
    tooltip: "Optional interval to enforce between repeats (whole numbers only)."
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].fullwidth
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "number",
    className: "form-control",
    placeholder: "",
    value: repeatIntervalNumber,
    onChange: function onChange(e) {
      onRepeatIntervalNumberChange(e.target.value);
    }
  }), /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], {
    data: [{
      value: 'month',
      label: 'month(s)'
    }, {
      value: 'week',
      label: 'week(s)'
    }, {
      value: 'day',
      label: 'day(s)'
    }, {
      value: 'hour',
      label: 'hour(s)'
    }, {
      value: 'minute',
      label: 'minute(s)'
    }],
    onChange: function onChange(e) {
      onRepeatIntervalUnitsChange(e.value);
    },
    textField: "label",
    value: localRepeatUnits,
    valueField: "value"
  }))));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].isRepeatedContainer
  }, renderIsRepeatedToggle, isRepeated.value && renderRepeatInterval);
};
var _default = exports["default"] = RepeatConfig;